var map = {
	"./coin3-dead.png": 59041,
	"./coin3.png": 20834,
	"./coin4-dead.png": 17339,
	"./coin4.png": 75259,
	"./player1-dead.png": 21750,
	"./player1.png": 3846,
	"./player2-dead.png": 60336,
	"./player2.png": 53434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51643;